var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLikeOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B69AF09A-1A4F-4083-ACBA-76DEEF8AED19") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "00_main",
    transform: "translate(-662.000000, -1040.000000)",
    fill: "#007CFB"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cards/offer_horizontal-copy-5",
    transform: "translate(150.000000, 864.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "button/secondary/icon",
    transform: "translate(504.000000, 168.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/24px/like_off",
    transform: "translate(8.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9770937,9.69589075 C19.9219687,9.52909441 19.7753125,9.4075367 19.59875,9.38235294 L14.6386562,8.67398292 L12.420375,4.25678221 C12.3414375,4.09953727 12.1784687,4 12.0000625,4 C11.821625,4 11.6586875,4.09953727 11.5797187,4.25678221 L9.36134375,8.67398292 L4.40134375,9.38235294 C4.2248125,9.4075367 4.07809375,9.52909441 4.02296875,9.69586004 C3.9678125,9.86265637 4.0138125,10.04573 4.14159375,10.168117 L7.73059375,13.6064372 L6.88346875,18.4614668 C6.85328125,18.6343134 6.92559375,18.8089413 7.0699375,18.9120411 C7.15159375,18.9703323 7.2483125,19 7.3455,19 C7.420125,19 7.495,18.9825249 7.5635625,18.9470834 L12.0000312,16.6548085 L16.4363125,18.9470527 C16.5942812,19.0286542 16.785625,19.0150795 16.9299687,18.9120104 C17.0743125,18.8089413 17.1466562,18.634252 17.1165,18.4614054 L16.2690937,13.6064372 L19.8585,10.1680862 C19.98625,10.04573 20.0322812,9.86265637 19.9770937,9.69589075 Z",
    id: "Path"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeOn);
export default __webpack_public_path__ + "static/media/like_on.6a4a8670.svg";
export { ForwardRef as ReactComponent };